<template>
  <BaseTemplate app-name="Feed" page-title="">
      <template #content>
          <!-- Animated Sidebar Toggle Button - Improved positioning for mobile -->

          <div class="fixed right-0 top-16 h-[calc(100%-4rem)] bg-white dark:bg-gray-800 shadow-xl z-40 transition-all duration-300 ease-in-out overflow-hidden"
:class="[isSidebarVisible ? 'w-[85vw] sm:w-64' : 'w-0']">

  <div class="p-4 sm:p-5  border-gray-200 dark:border-gray-700 flex items-center">
  <div class="p-4 sm:p-5  border-gray-200 dark:border-gray-700 flex items-center justify-between">
  <div class="flex items-center">
      <Users class="w-5 h-5 mr-2 text-blue-500" />
      <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Grupos</h2>
  </div>

  <!-- Botão recolher -->
  <button v-if="isSidebarVisible" @click="toggleSidebar"
      class="ml-2 text-gray-500 hover:text-blue-600 dark:hover:text-blue-400 transition">
      <ChevronRight class="w-5 h-5" />
  </button>
</div>
<button
  v-if="canCreateFeedGroups"
  type="button"
  @click.stop.prevent="openCreateGroupModal"
  class="ml-3 text-xs bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 transition"
>
  Novo
</button>

          </div>
          <div class="p-3 sm:p-4">
              <ul class="space-y-2 sm:space-y-3">
                  <li v-for="group in groups" :key="group.id" class="transition-all duration-200">
                      <div class="w-full py-2 px-3 rounded-lg transition-all duration-200 flex flex-wrap justify-between items-center gap-2"
                          :class="[
                              selectedGroupId === group.id
                                  ? 'bg-blue-100 text-blue-600 font-semibold dark:bg-blue-900/30 dark:text-blue-400'
                                  : 'text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700/50'
                          ]">
                         <div class="flex items-center cursor-pointer text-sm sm:text-base" @click="selectGroup(group.id)">

                              <Users2 class="w-4 h-4 mr-2"
                                  :class="selectedGroupId === group.id ? 'text-blue-500' : 'text-gray-400'" />
                              {{ group.nome }}
                          </div>
                          <button
                            v-if="canManageFeedGroups"
                            type="button"
                            @click.stop.prevent="openEditGroupModal(group)"
                            class="text-blue-500 hover:text-blue-700 text-xs"
                          >
                            Editar
                          </button>

                      </div>
                  </li>
              </ul>
          </div>
      </div>
      <!-- Botão flutuante para abrir o menu quando sidebar estiver recolhida -->
<button v-if="!isSidebarVisible"
  @click="toggleSidebar"
  class="fixed right-2 top-[4.5rem] z-50 bg-blue-600 text-white p-2 rounded-full shadow hover:bg-blue-700 transition-all duration-200">
  <ChevronLeft class="w-5 h-5" />
</button>


          <!-- Main Content - Improved padding for mobile -->
          <div class="container mx-auto px-3 sm:px-4 py-4 md:py-8 transition-all duration-300"
              :class="{ 'pr-[90vw] sm:pr-72': isSidebarVisible }">
              <div v-if="feedAcessoNegado" class="mb-6 rounded-lg border border-amber-300 bg-amber-50 text-amber-700 px-4 py-3">
                  Seu usuário não possui permissão para visualizar o feed.
              </div>
              <!-- Create Post Card - Improved for mobile -->
              <div class="bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 p-4 sm:p-6 mb-6" v-if="userPermissoes.pode_publicar">
                  <div class="flex items-start gap-3 sm:gap-4">
                      <!-- Avatar -->
                      <div class="w-10 h-10 sm:w-12 sm:h-12 rounded-full overflow-hidden shadow-sm flex-shrink-0">
                          <img 
                              :src="profileImage || '/default-avatar.png'" 
                              alt="User profile" 
                              class="w-full h-full object-cover"
                          />
                      </div>

                      <div class="flex-1 space-y-3 sm:space-y-4">
                          <!-- Textarea -->
                          <textarea
                              v-model="newPostContent"
                              placeholder="O que você está pensando?"
                              rows="3"
                              class="w-full border border-gray-300 dark:border-gray-600 rounded-lg p-3 sm:p-4 dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none transition"
                          ></textarea>

                          <!-- Ações - Improved layout for mobile -->
                          <div class="flex flex-col sm:flex-row justify-center sm:justify-between gap-3 sm:gap-4">

                              <!-- Uploads - Made more compact on mobile -->
                              <div class="flex flex-wrap gap-2 sm:gap-3">
                                  <!-- Botão de imagem -->
                                  <label for="image-upload" class="flex cursor-pointer items-center gap-1 rounded-lg px-2 py-1 text-xs text-gray-500 transition hover:bg-gray-100 hover:text-blue-600 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-blue-400 sm:text-sm">
                                      <Image class="w-4 h-4 sm:w-5 sm:h-5" />
                                      <span class="inline">Imagem</span>
                                  </label>
                                  <input type="file" id="image-upload" accept="image/*" @change="handleImageUpload" class="hidden" />

                                  <!-- Botão de vídeo -->
                                  <label for="video-upload" class="flex cursor-pointer items-center gap-1 rounded-lg px-2 py-1 text-xs text-gray-500 transition hover:bg-gray-100 hover:text-blue-600 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-blue-400 sm:text-sm">
                                      <Video class="w-4 h-4 sm:w-5 sm:h-5" />
                                      <span class="inline">Vídeo</span>
                                  </label>
                                  <input type="file" id="video-upload" accept="video/*" @change="handleVideoUpload" class="hidden" />

                                  <!-- Botão de documento -->
                                  <label for="document-upload" class="flex cursor-pointer items-center gap-1 rounded-lg px-2 py-1 text-xs text-gray-500 transition hover:bg-gray-100 hover:text-blue-600 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-blue-400 sm:text-sm">
                                      <FileText class="w-4 h-4 sm:w-5 sm:h-5" />
                                      <span class="inline">Documento</span>
                                  </label>
                                  <input type="file" id="document-upload" accept=".pdf,.doc,.docx" @change="handleDocumentUpload" class="hidden" />
                              </div>

                              <!-- Botão de publicar -->
                              <button
                                  @click="createPost"
                                  class="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-4 sm:px-6 py-2 rounded-lg shadow-md transition hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                                  :disabled="!newPostContent.trim() || (!selectedGroupId && !isCoordenadorFeed)"
                              >
                                  <div class="flex items-center gap-2 justify-center">
                                      <Send class="w-4 h-4" />
                                      <span>Publicar</span>
                                  </div>
                              </button>
                          </div>

                          <!-- Aviso de grupo -->
                          <div v-if="!selectedGroupId && !isCoordenadorFeed" class="flex items-center text-xs sm:text-sm text-amber-600 dark:text-amber-400 gap-1">
                              <AlertCircle class="w-4 h-4" />
                              <span>Selecione um grupo antes de publicar</span>
                          </div>

                          <!-- Preview de imagem - Improved for mobile -->
                          <div v-if="newPostImage" class="flex w-fit items-center gap-2 rounded-lg bg-gray-50 p-1.5 dark:bg-gray-700/50 sm:gap-3 sm:p-2">
                              <img :src="newPostImage" alt="Uploaded image" class="rounded-lg w-24 h-24 sm:w-32 sm:h-32 object-cover" />
                              <button @click="removeImage" class="rounded-full p-0.5 text-red-600 transition hover:bg-red-100 hover:text-red-800 dark:hover:bg-red-900/20 sm:p-1"><X class="w-4 h-4 sm:w-5 sm:h-5" /></button>
                          </div>

                          <!-- Preview de vídeo - Improved for mobile -->
                          <div v-if="newPostVideo?.previewUrl" class="flex w-fit items-center gap-2 rounded-lg bg-gray-50 p-1.5 dark:bg-gray-700/50 sm:gap-3 sm:p-2">
                              <video :src="newPostVideo.previewUrl" controls class="rounded-lg w-36 sm:w-48 max-h-36 sm:max-h-48 object-cover"></video>
                              <button @click="removeVideo" class="rounded-full p-0.5 text-red-600 transition hover:bg-red-100 hover:text-red-800 dark:hover:bg-red-900/20 sm:p-1"><X class="w-4 h-4 sm:w-5 sm:h-5" /></button>
                          </div>

                          <!-- Preview de documento -->
                          <div v-if="newPostDocumentName" class="flex w-fit items-center gap-2 rounded-lg bg-gray-50 p-1.5 dark:bg-gray-700/50 sm:gap-3 sm:p-2">
                              <FileText class="w-4 h-4 sm:w-5 sm:h-5 text-blue-500" />
                              <span class="text-xs sm:text-sm text-gray-700 dark:text-gray-300 truncate max-w-[150px] sm:max-w-none">{{ newPostDocumentName }}</span>
                              <button @click="removeDocument" class="rounded-full p-0.5 text-red-600 transition hover:bg-red-100 hover:text-red-800 dark:hover:bg-red-900/20 sm:p-1"><X class="w-4 h-4 sm:w-5 sm:h-5" /></button>
                          </div>
                      </div>
                  </div>
              </div>

              <!-- Posts Feed -->
              <div class="space-y-6" v-if="selectedGroupId">
                  <div v-if="posts.length === 0" class="text-center py-8 sm:py-10">
                      <div class="inline-flex rounded-full bg-blue-50 dark:bg-blue-900/20 p-3 sm:p-4 mb-3 sm:mb-4">
                          <MessageSquare class="w-5 h-5 sm:w-6 sm:h-6 text-blue-500" />
                      </div>
                      <h3 class="text-base sm:text-lg font-medium text-gray-900 dark:text-white mb-1">Nenhuma publicação neste
                          grupo ainda</h3>
                      <p class="text-sm text-gray-500 dark:text-gray-400">Seja o primeiro a compartilhar algo interessante!
                      </p>
                  </div>

                  <transition-group name="list" tag="div" class="space-y-6">
                      <div v-for="post in posts" :key="post.id" :id="`feed-post-${post.id}`"
                          :class="[
                              'bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden',
                              postEmFocoId === post.id ? 'ring-2 ring-blue-400' : ''
                          ]">
                          <!-- Post Header -->
                          <div class="p-4 sm:p-5 flex justify-between items-center">
                              <div class="flex items-center space-x-2 sm:space-x-3">
                                  <div
                                      class="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gradient-to-r from-blue-400 to-blue-600 flex items-center justify-center text-white overflow-hidden">
                                      <img 
                                          :src="post.author.avatar || CircleUserRound" 
                                          :alt="post.author.name"
                                          class="w-full h-full object-cover" 
                                      />
                                  </div>
                                  <div>
                                      <h3 class="font-semibold text-sm sm:text-base text-gray-900 dark:text-white">{{ post.author.name }}</h3>
                                      <p class="text-xs text-gray-500 dark:text-gray-400">{{ formatDate(post.createdAt) }}</p>
                                  </div>
                              </div>

                              <div class="relative post-menu-wrapper">
                                  <button @click.stop="togglePostMenu(post.id)"
                                      class="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300 p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200">
                                      <MoreVertical class="w-5 h-5" />
                                  </button>

                                  <div v-if="activePostMenuId === post.id"
                                      @click.stop
                                      class="absolute right-0 mt-2 w-40 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg z-50">
                                      <button v-if="podeEditarPost(post)" @click="startEditPost(post)"
                                          class="w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 text-sm">Editar</button>
                                      <button v-if="podeExcluirPost()" @click="deletePost(post.id)"
                                          class="w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 text-sm text-red-600">Excluir</button>
                                      <button v-if="podeOcultarComentariosPost()" @click="toggleComentariosOcultos(post)"
                                          class="w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 text-sm">
                                          {{ post.comentariosOcultos ? 'Exibir comentários' : 'Ocultar comentários' }}
                                      </button>
                                  </div>
                              </div>
                          </div>

                          <!-- Post Content -->
                          <div class="px-4 sm:px-5 pb-3">
                              <div v-if="editingPostId === post.id" class="mb-4">
                                  <textarea v-model="editedContent"
                                      class="w-full p-2 rounded border dark:bg-gray-700 dark:text-white mb-2"
                                      rows="3"></textarea>
                                  <div class="flex gap-3">
                                      <button @click="saveEditedPost(post)"
                                          class="text-blue-600 font-medium">Salvar</button>
                                      <button @click="cancelEditPost" class="text-gray-500">Cancelar</button>
                                  </div>
                              </div>
                              <p v-else class="text-sm sm:text-base text-gray-800 dark:text-gray-200 mb-4 whitespace-pre-line">
                                  {{ post.content }}
                              </p>

                              <img v-if="post.image" :src="post.image" :alt="'Post image by ' + post.author.name"
                                  class="w-full max-h-96 object-cover rounded-lg mb-4 cursor-pointer transform transition-transform duration-300 hover:scale-[1.01]"
                                  @click="openImage(post.image)" />

                              <video v-if="post.video" :src="post.video" controls
                                  class="w-full h-auto rounded-lg mb-4"></video>
                              
                              <div v-if="Array.isArray(post.documentos) && post.documentos.length > 0" class="space-y-2 mb-4">
                                  <div v-for="(document, index) in post.documentos" :key="index"
                                      class="flex items-center space-x-2 p-2 sm:p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg transition-colors duration-200 hover:bg-gray-100 dark:hover:bg-gray-700">
                                      <FileText class="w-4 h-4 sm:w-5 sm:h-5 text-blue-500" />
                                      <a :href="document.url" download
                                          class="text-xs sm:text-sm text-blue-600 dark:text-blue-400 hover:underline flex-1 truncate">
                                          {{ document.nome ? document.nome.split('_').slice(1).join('_') : document.split('/').pop() }}
                                      </a>
                                      <Download class="w-4 h-4 text-gray-500" />
                                  </div>
                              </div>
                          </div>

                          <!-- Post Stats -->
                          <div
                              class="px-4 sm:px-5 py-2 sm:py-3 border-t border-gray-200 dark:border-gray-700 flex justify-between items-center text-xs sm:text-sm">
                              <div class="relative inline-block text-left">
                                  <!-- Menu de emojis -->
                                  <div v-show="isEmojiMenuOpen(post.id)"
                                      class="absolute z-10 -top-20 mt-2 w-48 sm:w-56 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg shadow-xl animate-fade-in">
                                      <div class="grid grid-cols-5 gap-1 sm:gap-2 p-2 sm:p-3 text-base sm:text-lg cursor-pointer">
                                          <span
                                              v-for="emoji in emojiOptions"
                                              :key="emoji" @click="reactToPost(post.id, emoji)"
                                              class="flex items-center justify-center p-1 sm:p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors duration-200 transform hover:scale-110">
                                              {{ emoji }}
                                          </span>
                                      </div>
                                  </div>

                                  <div v-if="userPermissoes.pode_visualizar_reacoes" class="flex items-center gap-1">
                                      <div class="flex items-center gap-1">
                                          <template
                                              v-for="(emoji, index) in Array.from(new Set(post.reactionUsersEmojis || [])).slice(0, 3)"
                                              :key="index">
                                              <span class="text-base sm:text-lg cursor-pointer" @click="openReactionsModal(post)">
                                                  {{ emoji }}
                                              </span>
                                          </template>

                                          <span v-if="post.reactionUsersEmojis.length > 3"
                                              class="text-xs sm:text-sm font-semibold cursor-pointer hover:text-blue-600 dark:hover:text-blue-400"
                                              @click="openReactionsModal(post)">
                                              +{{ post.reactionUsersEmojis.length - 3 }}
                                          </span>
                                      </div>
                                  </div>
                              </div>
                              <div v-if="userPermissoes.pode_visualizar_reacoes" class="flex items-center space-x-1 relative group">
                                  <!-- Tooltip com usuários que reagiram -->
                                  <div
                                      class="absolute hidden group-hover:block bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 text-xs text-gray-700 dark:text-white rounded-lg shadow-lg p-2 sm:p-3 -top-24 left-0 z-20 min-w-[120px] sm:min-w-[140px] max-w-[180px] sm:max-w-[220px] animate-fade-in">
                                      <p v-if="!post.reactionUsers || post.reactionUsers.length === 0">Sem reações
                                          ainda</p>
                                      <ul v-else class="space-y-1">
                                          <li v-for="user in post.reactionUsers" :key="user"
                                              class="flex items-center">
                                              <span class="w-1 h-1 bg-blue-500 rounded-full mr-2"></span>
                                              {{ user }}
                                          </li>
                                      </ul>
                                  </div>
                              </div>
                              <button v-if="!post.comentariosOcultos" @click="toggleComments(post.id)"
                                  class="flex items-center text-xs sm:text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200">
                                  <MessageSquare class="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
                                  {{ post.total_comentarios || 0 }} comentários
                              </button>
                          </div>
                          
                          <!-- Post Actions -->
                          <div
                              class="px-4 sm:px-5 py-2 sm:py-3 flex justify-center gap-4 sm:gap-6 border-t border-gray-200 dark:border-gray-700">
                              <!-- Botão Reagir -->
                              <button v-if="userPermissoes.pode_reagir" @click="toggleEmojiMenu(post.id)"
                                  class="flex items-center gap-1 sm:gap-2 px-3 sm:px-4 py-1 sm:py-2 rounded-lg transition-colors duration-200 hover:bg-gray-100 dark:hover:bg-gray-700 text-xs sm:text-sm"
                                  :class="post.userReaction ? 'text-blue-600 dark:text-blue-400 font-semibold' : 'text-gray-600 dark:text-gray-400'">
                                  <span v-if="post.userReaction" class="text-base sm:text-lg">{{ post.userReaction }}</span>
                                  <ThumbsUp v-else class="w-4 h-4 sm:w-5 sm:h-5" />
                                  <span>Reagir</span>
                              </button>

                              <!-- Botão Comentar -->
                              <button v-if="!post.comentariosOcultos" @click="toggleComments(post.id)"
                                  class="flex items-center gap-1 sm:gap-2 px-3 sm:px-4 py-1 sm:py-2 rounded-lg transition-colors duration-200 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-400 text-xs sm:text-sm">
                                  <MessageSquare class="w-4 h-4 sm:w-5 sm:h-5" />
                                  <span>Comentar</span>
                              </button>
                          </div>
                          
                          <!-- Comments Section -->
                          <div v-if="post.showComments"
                              class="px-4 sm:px-5 py-3 sm:py-4 bg-white dark:bg-gray-750 border-t border-gray-200 dark:border-gray-700 animate-fade-in-down">
                              <div v-if="post.showComments">
                                  <div v-if="post.comentariosOcultos"
                                      class="text-center text-xs sm:text-sm text-gray-500 dark:text-gray-400 italic">
                                      Comentários ocultos
                                  </div>
                                  <div v-else>
                                      <!-- Renderiza os comentários normalmente -->
                                  </div>
                              </div>
                              
                              <!-- Comment Input -->
                              <div v-if="userPermissoes.pode_comentar" class="flex items-start space-x-2 sm:space-x-3 mb-4 sm:mb-5">
                                  <div
                                      class="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-gradient-to-r from-blue-400 to-blue-600 flex items-center justify-center text-white overflow-hidden flex-shrink-0">
                                      <img 
                                          :src="profileImage || '/default-avatar.png'" 
                                          alt="User profile" 
                                          class="w-full h-full object-cover"
                                      />
                                  </div>

                                  <div class="flex-1 relative">
                                      <textarea v-model="post.newComment" placeholder="Escreva um comentário..."
                                          class="w-full border border-gray-200 dark:border-gray-600 rounded-lg p-2 sm:p-3 pr-10 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white transition-all duration-200 text-xs sm:text-sm"
                                          rows="1"></textarea>

                                      <button @click="addComment(post.id)"
                                          class="absolute right-2 sm:right-3 bottom-2 sm:bottom-3 text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors duration-200"
                                          :disabled="!post.newComment.trim()">
                                          <Send class="w-4 h-4 sm:w-5 sm:h-5" />
                                      </button>
                                  </div>
                              </div>
                              <div v-else class="text-xs sm:text-sm text-gray-500 dark:text-gray-400 mb-4">
                                  Seu grupo não possui permissão para comentar.
                              </div>

                              <!-- Comments List -->
                              <div class="space-y-3 sm:space-y-4">
                                  <transition-group name="list" tag="div" class="space-y-3 sm:space-y-4">
                                      <div v-for="comment in post.comments" :key="comment.id"
                                          class="flex space-x-2 sm:space-x-3 animate-fade-in">
                                          <div
                                              class="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-gradient-to-r from-blue-400 to-blue-600 flex items-center justify-center text-white overflow-hidden flex-shrink-0">
                                              <img 
                                                  :src="comment.usuario_imagem || CircleUserRound" 
                                                  alt="User profile" 
                                                  class="w-full h-full object-cover"
                                              />
                                          </div>
                                          <div class="flex-1">
                                              <div
                                                  class="bg-white dark:bg-gray-700 rounded-lg p-2 sm:p-3 shadow-sm border border-gray-200 dark:border-gray-600">
                                                  <h4 class="font-semibold text-gray-900 dark:text-white text-xs sm:text-sm">{{
                                                      comment.usuario_nome }}</h4>
                                                  <p class="text-gray-800 dark:text-gray-200 text-xs sm:text-sm mt-1">{{
                                                      comment.comentario }}</p>
                                              </div>

                                              <div class="flex items-center mt-1 sm:mt-2 space-x-3 sm:space-x-4 text-[10px] sm:text-xs">
                                                  <div v-if="userPermissoes.pode_reagir" class="relative">
                                                      <div v-show="isCommentEmojiMenuOpen(comment.id)"
                                                          class="absolute z-10 -top-16 mt-2 w-40 sm:w-52 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg shadow-xl animate-fade-in">
                                                          <div class="grid grid-cols-5 gap-1 p-2 text-sm sm:text-base cursor-pointer">
                                                              <span v-for="emoji in emojiOptions" :key="emoji"
                                                                  @click="reactToComment(post.id, comment.id, emoji)"
                                                                  class="flex items-center justify-center p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors duration-200 transform hover:scale-110">
                                                                  {{ emoji }}
                                                              </span>
                                                          </div>
                                                      </div>
                                                      <button @click="toggleCommentEmojiMenu(comment.id)"
                                                          class="font-medium transition-colors duration-200 flex items-center"
                                                          :class="comment.userReaction ? 'text-blue-600 dark:text-blue-400' : 'text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400'">
                                                          <span v-if="comment.userReaction" class="mr-1">{{ comment.userReaction }}</span>
                                                          <ThumbsUp v-else class="w-3 h-3 mr-1" />
                                                          Reagir
                                                      </button>
                                                  </div>

                                                  <button v-if="userPermissoes.pode_visualizar_reacoes && (comment.reactionUsersEmojis || []).length > 0"
                                                      @click="openReactionsModal(comment, 'Reações do comentário')"
                                                      class="font-medium text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200">
                                                      {{ comment.likes || 0 }} reações
                                                  </button>

                                                  <button v-if="userPermissoes.pode_responder_comentario" @click="toggleReplyInput(post.id, comment.id)"
                                                      class="font-medium text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200 flex items-center">
                                                      Responder
                                                  </button>

                                                  <span class="text-gray-500 dark:text-gray-400">{{
                                                      formatDate(comment.data_criacao) }}</span>
                                              </div>

                                              <!-- Reply Input -->
                                              <div v-if="comment.showReplyInput && userPermissoes.pode_responder_comentario"
                                                  class="mt-2 sm:mt-3 flex items-start space-x-2 animate-fade-in-down">
                                                  <div
                                                      class="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-blue-400 to-blue-600 flex items-center justify-center text-white overflow-hidden flex-shrink-0">
                                                      <img 
                                                          :src="profileImage || '/default-avatar.png'" 
                                                          alt="User profile" 
                                                          class="w-full h-full object-cover"
                                                      />
                                                  </div>

                                                  <div class="flex-1 relative">
                                                      <textarea v-model="comment.newReply"
                                                          placeholder="Escreva uma resposta..."
                                                          class="w-full border border-gray-200 dark:border-gray-600 rounded-lg p-1.5 sm:p-2 pr-8 sm:pr-10 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white transition-all duration-200"
                                                          rows="1"></textarea>

                                                      <button @click="addReply(post.id, comment)"
                                                          class="absolute right-1.5 sm:right-2 bottom-1.5 sm:bottom-2 text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors duration-200"
                                                          :disabled="!(comment.newReply && comment.newReply.trim())">
                                                          <Send class="w-3 h-3 sm:w-4 sm:h-4" />
                                                      </button>
                                                  </div>
                                              </div>

                                              <!-- Replies -->
                                              <div v-if="comment.replies && comment.replies.length > 0"
                                                  class="mt-2 sm:mt-3 space-y-2 sm:space-y-3 pl-3 sm:pl-4 border-l-2 border-gray-200 dark:border-gray-600">
                                                  <transition-group name="list" tag="div" class="space-y-2 sm:space-y-3">
                                                      <div v-for="reply in comment.replies" :key="reply.id"
                                                          class="flex space-x-1.5 sm:space-x-2 animate-fade-in">
                                                          <div
                                                              class="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-gray-400 to-gray-500 flex items-center justify-center text-white overflow-hidden flex-shrink-0">
                                                              <img :src="reply.author.avatar" :alt="reply.author.name"
                                                                  class="w-full h-full object-cover" />
                                                          </div>

                                                          <div>
                                                              <div
                                                                  class="bg-white dark:bg-gray-700 rounded-lg p-1.5 sm:p-2 shadow-sm">
                                                                  <h5
                                                                      class="font-semibold text-gray-900 dark:text-white text-[10px] sm:text-xs">
                                                                      {{ reply.author.name }}</h5>
                                                                  <p
                                                                      class="text-gray-800 dark:text-gray-200 text-[10px] sm:text-xs mt-0.5 sm:mt-1">
                                                                      {{ reply.content }}</p>
                                                              </div>

                                                              <div class="flex items-center mt-1 space-x-2 sm:space-x-3 text-[10px] sm:text-xs">
                                                                  <button v-if="userPermissoes.pode_responder_comentario"
                                                                      @click="prepareReplyToReply(post.id, comment.id, reply)"
                                                                      class="font-medium text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200">
                                                                      Responder
                                                                  </button>

                                                                  <span class="text-gray-500 dark:text-gray-400">{{
                                                                      formatDate(reply.createdAt) }}</span>
                                                              </div>
                                                          </div>
                                                      </div>
                                                  </transition-group>
                                              </div>
                                          </div>
                                      </div>
                                  </transition-group>

                                  <div v-if="post.total_comentarios > post.comments.length" class="mt-3 sm:mt-4 text-center">
                                      <button
                                          class="text-xs sm:text-sm text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 font-medium px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-all duration-200"
                                          @click="carregarMaisComentarios(post)">
                                          Carregar mais comentários
                                      </button>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </transition-group>
              </div>

          </div>

          <transition name="fade">
              <div v-if="isReactionsModalOpen"
                  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 p-4"
                  @click.self="closeReactionsModal">
                  <div class="w-full max-w-md bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-200 dark:border-gray-700">
                      <div class="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-700">
                          <h3 class="text-sm sm:text-base font-semibold text-gray-900 dark:text-white">{{ reactionsModalTitle }}</h3>
                          <button @click="closeReactionsModal" class="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
                              <X class="w-4 h-4" />
                          </button>
                      </div>
                      <div class="px-4 pt-3 flex flex-wrap gap-2">
                          <button v-for="emoji in Object.keys(reactionsModalPost?.reactionUsersPerEmoji || {})" :key="emoji"
                              @click="selectedEmojiTab = emoji"
                              class="px-2 py-1 rounded-md text-sm border transition-colors duration-200"
                              :class="selectedEmojiTab === emoji ? 'bg-blue-100 text-blue-700 border-blue-300 dark:bg-blue-900/40 dark:text-blue-300 dark:border-blue-700' : 'bg-gray-50 text-gray-700 border-gray-200 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600'">
                              {{ emoji }}
                          </button>
                      </div>
                      <div class="p-4 max-h-72 overflow-y-auto">
                          <div v-if="!selectedEmojiTab || !(reactionsModalPost?.reactionUsersPerEmoji?.[selectedEmojiTab] || []).length"
                              class="text-sm text-gray-500 dark:text-gray-400">
                              Sem usuários para esta reação.
                          </div>
                          <ul v-else class="space-y-2">
                              <li v-for="nome in reactionsModalPost.reactionUsersPerEmoji[selectedEmojiTab]" :key="`${selectedEmojiTab}-${nome}`"
                                  class="text-sm text-gray-800 dark:text-gray-100">
                                  {{ nome }}
                              </li>
                          </ul>
                      </div>
                  </div>
              </div>
          </transition>

          <!-- Modal para exibir a imagem em tamanho original -->
          <transition name="fade">
              <div v-if="isModalOpen"
                  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 p-4"
                  @click.self="closeModal">
                  <div class="relative max-w-full max-h-full animate-scale-in">
                      <img :src="selectedImage" alt="Imagem em tamanho original"
                          class="max-w-full max-h-[85vh] rounded-lg shadow-2xl" />

                      <button @click="closeModal"
                          class="absolute top-2 sm:top-4 right-2 sm:right-4 text-white bg-black bg-opacity-50 rounded-full p-1.5 sm:p-2 hover:bg-opacity-70 transition-colors duration-200">
                          <X class="h-5 w-5 sm:h-6 sm:w-6" />
                      </button>
                  </div>
              </div>
          </transition>

          <transition name="fade">
              <div
                  v-if="isGroupModalOpen"
                  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 p-4"
                  @click.self="closeGroupModal"
              >
                  <div class="relative bg-white dark:bg-gray-800 w-full max-w-3xl rounded-lg shadow-xl p-4 max-h-[80vh] overflow-hidden">
                      <div class="overflow-y-auto max-h-[calc(80vh-2rem)] pb-20 pr-1">
                      <div class="flex items-center justify-between mb-4">
                          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
                              {{ groupDraft.id ? 'Editar Grupo de Feed' : 'Novo Grupo de Feed' }}
                          </h3>
                          <button type="button" @click="closeGroupModal" class="text-gray-500 hover:text-gray-700">
                              <X class="w-5 h-5" />
                          </button>
                      </div>

                      <div v-if="groupModalError" class="mb-3 text-sm text-red-600">
                          {{ groupModalError }}
                      </div>

                      <label class="block text-sm text-gray-700 dark:text-gray-300 mb-1">Nome do grupo</label>
                      <input
                          v-model="groupDraft.nome"
                          type="text"
                          class="w-full mb-4 border rounded px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                      />

                      <input
                          v-model="searchUsersFeed"
                          type="text"
                          placeholder="Pesquisar usuário..."
                          class="w-full mb-4 border rounded px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                      />

                      <div class="mb-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 text-xs">
                          <div class="px-2 py-1 rounded bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200"><strong>Leitor:</strong> visualiza, reage e comenta</div>
                          <div class="px-2 py-1 rounded bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200"><strong>Colaborador:</strong> leitor + publicar</div>
                          <div class="px-2 py-1 rounded bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200"><strong>Moderador:</strong> colaborador + editar e ocultar comentários</div>
                          <div class="px-2 py-1 rounded bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200"><strong>Administrador:</strong> todas permissões</div>
                      </div>

                      <div class="overflow-x-auto border border-gray-200 dark:border-gray-700 rounded-lg">
                          <table class="w-full text-sm">
                              <thead class="bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200">
                                  <tr>
                                      <th class="px-3 py-2 text-left">Usuário</th>
                                      <th class="px-3 py-2 text-center">No grupo</th>
                                      <th class="px-3 py-2 text-center">Perfil de permissão</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr
                                      v-for="usuario in filteredUsersFeed"
                                      :key="usuario.id"
                                      class="border-t border-gray-200 dark:border-gray-700"
                                  >
                                      <td class="px-3 py-2 text-gray-800 dark:text-gray-200">{{ usuario.nome }}</td>
                                      <td class="px-3 py-2 text-center">
                                          <input
                                              type="checkbox"
                                              :checked="isUsuarioSelecionadoNoGrupo(usuario.id)"
                                              @change="toggleUsuarioGrupo(usuario)"
                                          />
                                      </td>
                                      <td class="px-3 py-2 text-center">
                                          <select
                                              :disabled="!isUsuarioSelecionadoNoGrupo(usuario.id)"
                                              :value="getPerfilUsuarioGrupo(usuario.id)"
                                              @change="aplicarPerfilUsuarioGrupo(usuario.id, $event.target.value)"
                                              class="border rounded px-2 py-1 dark:bg-gray-700 dark:border-gray-600 dark:text-white disabled:opacity-50"
                                          >
                                              <option value="leitor">Leitor</option>
                                              <option value="colaborador">Colaborador</option>
                                              <option value="moderador">Moderador</option>
                                              <option value="administrador">Administrador</option>
                                              <option value="personalizado">Personalizado</option>
                                          </select>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                      </div>

                      <div class="absolute bottom-0 left-0 right-0 z-10 flex justify-end gap-2 bg-white dark:bg-gray-800 px-4 py-3 border-t border-gray-200 dark:border-gray-700">
                          <button type="button" @click="closeGroupModal" class="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500">Cancelar</button>
                          <button type="button" :disabled="isSavingGroup" @click="saveGroupFeed" class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-60">
                              {{ isSavingGroup ? 'Salvando...' : 'Salvar Grupo' }}
                          </button>
                      </div>
                  </div>
              </div>
          </transition>

      </template>
  </BaseTemplate>
</template>

<script setup>
import { ref, onMounted, watch, computed, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import { useGrupoStore } from '@/stores/feed/feedStore';
import apiClient, { getUser } from '@/services/authService';
import { useUserStore } from '@/stores/userStore';
//import notificationService from '@/services/notificationService';

const grupoStore = useGrupoStore()
const userStore = useUserStore()
const route = useRoute()

const setSelectedGroupId = grupoStore.setSelectedGroupId


import BaseTemplate from '@/views/templates/BaseTemplate.vue';
import {
  Image,
  CircleUserRound,
  Video,
  FileText,
  Send,
  MoreVertical,
  ThumbsUp,
  MessageSquare,
  X,
  ChevronLeft,
  ChevronRight,
  Users,
  Users2,
  Download,
  AlertCircle
} from 'lucide-vue-next';

// Estado para novo post
const newPostContent = ref('');
const newPostImage = ref(null);
const newPostVideo = ref(null);
const newPostDocuments = ref([]);
const newPostDocumentName = ref(null);
const selectedEmojiTab = ref(null);
const emojiOptions = ['👍', '❤️', '😂', '😮', '😢', '👏', '🔥', '🎉', '👎', '💯'];
const posts = ref([]);
const feedAcessoNegado = ref(false);
const isCoordenadorFeed = ref(false);
const canManageFeedGroups = ref(false);
const canCreateFeedGroups = ref(false);
const currentUserId = ref(null);
const allUsersFeed = ref([]);
const searchUsersFeed = ref('');
const isGroupModalOpen = ref(false);
const isSavingGroup = ref(false);
const groupModalError = ref('');
const feedPermissionFields = [
  'pode_visualizar_feed',
  'pode_visualizar_reacoes',
  'pode_publicar',
  'pode_editar',
  'pode_excluir',
  'pode_ocultar_comentarios',
  'pode_comentar',
  'pode_responder_comentario',
  'pode_reagir'
];
const groupDraft = ref({
  id: null,
  nome: '',
  membros: []
});
// Estado para controlar o modal
const isModalOpen = ref(false);
const selectedImage = ref(null);

// Estado para o menu de emojis
const activeEmojiPostId = ref(null);
const activeEmojiCommentId = ref(null);
const permissoesFeedPadrao = {
  pode_visualizar_feed: true,
  pode_visualizar_reacoes: true,
  pode_publicar: false,
  pode_editar: false,
  pode_excluir: false,
  pode_ocultar_comentarios: false,
  pode_comentar: true,
  pode_responder_comentario: true,
  pode_reagir: true
};
const permissoesGlobais = ref({ ...permissoesFeedPadrao });
const userPermissoes = ref({ ...permissoesFeedPadrao });

const verificarPermissaoPostagem = async () => {
  try {
      if (!userStore.feedPermissions) {
          await getUser();
      }
      const responsePermissoes = userStore.feedPermissions || null;
      permissoesGlobais.value = {
          ...permissoesFeedPadrao,
          ...(responsePermissoes || {}),
      };
      userPermissoes.value = { ...permissoesGlobais.value };
  } catch (error) {
      console.error("Erro ao verificar permissão de postagem:", error);
      permissoesGlobais.value = {
          ...permissoesFeedPadrao,
          pode_publicar: false,
      };
      userPermissoes.value = { ...permissoesGlobais.value };
  }
};

// Estado para grupos
const selectedGroupId = computed(() => grupoStore.selectedGroupId)
const isSidebarVisible = ref(true);
const groups = ref([]);
const postEmFocoId = ref(null);
const isFeedAdmin = computed(() => {
  const gruposUsuario = userStore.grupos || [];
  return gruposUsuario.includes('superadmin') || gruposUsuario.includes('desenvolvedor');
});
const grupoAtualSelecionado = computed(() =>
  groups.value.find(item => Number(item.id) === Number(selectedGroupId.value)) || null
);
const isCurrentUserGroupAdmin = computed(() => {
  if (isFeedAdmin.value) return true;
  if (!grupoAtualSelecionado.value || !currentUserId.value) return false;
  return Number(grupoAtualSelecionado.value.responsavel_id) === Number(currentUserId.value);
});
const permissaoMembroAtualNoGrupo = computed(() => {
  if (!grupoAtualSelecionado.value || !currentUserId.value) return null;
  return (grupoAtualSelecionado.value.membros || []).find(
    membro => Number(membro.usuario_id) === Number(currentUserId.value)
  ) || null;
});
const podeAcaoNoPost = (campo) => {
  if (isCurrentUserGroupAdmin.value) return true;
  if (permissaoMembroAtualNoGrupo.value && campo in permissaoMembroAtualNoGrupo.value) {
    return Boolean(permissaoMembroAtualNoGrupo.value[campo]);
  }
  return Boolean(userPermissoes.value?.[campo]);
};
const ehAutorDoPost = (post) => Number(post?.author?.id) === Number(currentUserId.value);
const podeEditarPost = (post) => Boolean(ehAutorDoPost(post) || podeAcaoNoPost('pode_editar'));
const podeExcluirPost = () => Boolean(podeAcaoNoPost('pode_excluir'));
const podeOcultarComentariosPost = () => Boolean(podeAcaoNoPost('pode_ocultar_comentarios'));
const filteredUsersFeed = computed(() => {
  const termo = (searchUsersFeed.value || '').trim().toLowerCase();
  if (!termo) return allUsersFeed.value;
  return allUsersFeed.value.filter(usuario => String(usuario.nome || '').toLowerCase().includes(termo));
});

const perfisPermissaoGrupo = {
  leitor: {
    pode_visualizar_feed: true,
    pode_visualizar_reacoes: true,
    pode_publicar: false,
    pode_editar: false,
    pode_excluir: false,
    pode_ocultar_comentarios: false,
    pode_comentar: true,
    pode_responder_comentario: true,
    pode_reagir: true
  },
  colaborador: {
    pode_visualizar_feed: true,
    pode_visualizar_reacoes: true,
    pode_publicar: true,
    pode_editar: false,
    pode_excluir: false,
    pode_ocultar_comentarios: false,
    pode_comentar: true,
    pode_responder_comentario: true,
    pode_reagir: true
  },
  moderador: {
    pode_visualizar_feed: true,
    pode_visualizar_reacoes: true,
    pode_publicar: true,
    pode_editar: true,
    pode_excluir: false,
    pode_ocultar_comentarios: true,
    pode_comentar: true,
    pode_responder_comentario: true,
    pode_reagir: true
  },
  administrador: {
    pode_visualizar_feed: true,
    pode_visualizar_reacoes: true,
    pode_publicar: true,
    pode_editar: true,
    pode_excluir: true,
    pode_ocultar_comentarios: true,
    pode_comentar: true,
    pode_responder_comentario: true,
    pode_reagir: true
  }
};

const criarPermissoesPadraoMembro = (usuarioId, usuarioNome = '') => ({
  usuario_id: Number(usuarioId),
  usuario_nome: usuarioNome,
  ...perfisPermissaoGrupo.leitor
});

const aplicarPermissoesGrupoSelecionado = () => {
  if (!selectedGroupId.value || !currentUserId.value) {
    userPermissoes.value = { ...permissoesGlobais.value };
    return;
  }
  const grupoAtual = groups.value.find(item => Number(item.id) === Number(selectedGroupId.value));
  if (!grupoAtual) {
    userPermissoes.value = { ...permissoesGlobais.value };
    return;
  }
  if (isFeedAdmin.value) {
    userPermissoes.value = feedPermissionFields.reduce((acc, campo) => {
      acc[campo] = true;
      return acc;
    }, {});
    return;
  }
  if (Number(grupoAtual.responsavel_id) === Number(currentUserId.value)) {
    userPermissoes.value = feedPermissionFields.reduce((acc, campo) => {
      acc[campo] = true;
      return acc;
    }, {});
    return;
  }
  const permissaoMembro = (grupoAtual.membros || []).find(m => Number(m.usuario_id) === Number(currentUserId.value));
  if (!permissaoMembro) {
    userPermissoes.value = { ...permissoesFeedPadrao, pode_visualizar_feed: false };
    return;
  }
  userPermissoes.value = feedPermissionFields.reduce((acc, campo) => {
    acc[campo] = Boolean(permissaoMembro[campo]);
    return acc;
  }, {});
};

const isUsuarioSelecionadoNoGrupo = (usuarioId) =>
  groupDraft.value.membros.some(item => Number(item.usuario_id) === Number(usuarioId));

const getMembroGrupoByUsuario = (usuarioId) => {
  const membro = groupDraft.value.membros.find(item => Number(item.usuario_id) === Number(usuarioId));
  return membro || null;
};

const getPerfilUsuarioGrupo = (usuarioId) => {
  const membro = getMembroGrupoByUsuario(usuarioId);
  if (!membro) return 'leitor';
  const perfilEncontrado = Object.entries(perfisPermissaoGrupo).find(([, configuracao]) =>
    feedPermissionFields.every(campo => Boolean(membro[campo]) === Boolean(configuracao[campo]))
  );
  return perfilEncontrado ? perfilEncontrado[0] : 'personalizado';
};

const aplicarPerfilUsuarioGrupo = (usuarioId, perfil) => {
  if (perfil === 'personalizado') return;
  const membro = getMembroGrupoByUsuario(usuarioId);
  if (!membro) return;
  const configuracao = perfisPermissaoGrupo[perfil];
  if (!configuracao) return;
  feedPermissionFields.forEach(campo => {
    membro[campo] = Boolean(configuracao[campo]);
  });
};

const toggleUsuarioGrupo = (usuario) => {
  const indice = groupDraft.value.membros.findIndex(item => Number(item.usuario_id) === Number(usuario.id));
  if (indice >= 0) {
    if (Number(usuario.id) === Number(currentUserId.value)) return;
    groupDraft.value.membros.splice(indice, 1);
    return;
  }
  groupDraft.value.membros.push(criarPermissoesPadraoMembro(usuario.id, usuario.nome));
};

const openCreateGroupModal = async () => {
  groupModalError.value = '';
  searchUsersFeed.value = '';
  await fetchUsersForFeedGroup();
  groupDraft.value = {
    id: null,
    nome: '',
    membros: currentUserId.value
      ? [{
          ...criarPermissoesPadraoMembro(currentUserId.value, userStore.nome || 'Você'),
          ...perfisPermissaoGrupo.administrador
        }]
      : []
  };
  isGroupModalOpen.value = true;
};

const openEditGroupModal = async (group) => {
  groupModalError.value = '';
  searchUsersFeed.value = '';
  await fetchUsersForFeedGroup();
  groupDraft.value = {
    id: group.id,
    nome: group.nome || '',
    membros: Array.isArray(group.membros)
      ? group.membros.map(item => ({
          ...criarPermissoesPadraoMembro(item.usuario_id, item.usuario_nome || ''),
          ...item
        }))
      : []
  };
  if (currentUserId.value && !isUsuarioSelecionadoNoGrupo(currentUserId.value)) {
    groupDraft.value.membros.push({
      ...criarPermissoesPadraoMembro(currentUserId.value, userStore.nome || 'Você'),
      ...perfisPermissaoGrupo.administrador
    });
  }
  isGroupModalOpen.value = true;
};

const closeGroupModal = () => {
  isGroupModalOpen.value = false;
  groupModalError.value = '';
  searchUsersFeed.value = '';
  groupDraft.value = { id: null, nome: '', membros: [] };
};

const fetchUsersForFeedGroup = async () => {
  if (allUsersFeed.value.length > 0) return;
  try {
    const response = await apiClient.get('/api/v1/auth/users/');
    const data = Array.isArray(response.data) ? response.data : [];
    allUsersFeed.value = data.map(user => ({
      id: user.id,
      nome: `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.username
    }));
  } catch (error) {
    allUsersFeed.value = [];
  }
};

const saveGroupFeed = async () => {
  const nome = (groupDraft.value.nome || '').trim();
  if (!nome) {
    groupModalError.value = 'Informe o nome do grupo.';
    return;
  }
  if (!groupDraft.value.membros.length) {
    groupModalError.value = 'Selecione ao menos um usuário.';
    return;
  }
  isSavingGroup.value = true;
  groupModalError.value = '';
  const payload = {
    nome,
    membros: groupDraft.value.membros.map(item => {
      const permissao = { usuario_id: Number(item.usuario_id) };
      feedPermissionFields.forEach(campo => {
        permissao[campo] = Boolean(item[campo]);
      });
      return permissao;
    })
  };
  try {
    if (groupDraft.value.id) {
      await apiClient.put(`/api/v1/feed/gruposfeed/${groupDraft.value.id}/membros`, { membros: payload.membros });
    } else {
      await apiClient.post('/api/v1/feed/gruposfeed/', payload);
    }
    await fetchGroups();
    closeGroupModal();
  } catch (error) {
    groupModalError.value = error?.response?.data?.detail || 'Erro ao salvar grupo de feed.';
  } finally {
    isSavingGroup.value = false;
  }
};

// Funções para o modal de imagem
const openImage = (imageUrl) => {
  selectedImage.value = imageUrl;
  isModalOpen.value = true;
  document.body.style.overflow = 'hidden'; // Previne rolagem quando modal está aberto
};

const closeModal = () => {
  isModalOpen.value = false;
  selectedImage.value = null;
  document.body.style.overflow = ''; // Restaura rolagem
};

// Funções para o menu de emojis
const toggleEmojiMenu = (postId) => {
  if (!userPermissoes.value.pode_reagir) return;
  activeEmojiPostId.value = activeEmojiPostId.value === postId ? null : postId;
};

const isEmojiMenuOpen = (postId) => activeEmojiPostId.value === postId;
const toggleCommentEmojiMenu = (commentId) => {
  if (!userPermissoes.value.pode_reagir) return;
  activeEmojiCommentId.value = activeEmojiCommentId.value === commentId ? null : commentId;
};
const isCommentEmojiMenuOpen = (commentId) => activeEmojiCommentId.value === commentId;

// Funções para upload de mídia
const handleImageUpload = (event) => {
  const file = event.target.files[0];
  if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
          newPostImage.value = e.target.result;
      };
      reader.readAsDataURL(file);
  }
};

const handleVideoUpload = (event) => {
  const file = event.target.files[0];
  if (file) {
      newPostVideo.value = {
          file,
          previewUrl: URL.createObjectURL(file)
      };
  }
};

const removeVideo = () => {
  if (newPostVideo.value?.previewUrl) {
      URL.revokeObjectURL(newPostVideo.value.previewUrl); // limpeza
  }
  newPostVideo.value = null;
};


const handleDocumentUpload = (event) => {
  const files = event.target.files;
  if (files && files.length > 0) {
      const file = files[0];
      newPostDocuments.value = file;
      newPostDocumentName.value = file.name;
  }
};

const toggleComentariosOcultos = async (post) => {
  try {
      const response = await apiClient.put(`/api/v1/feed/posts/${post.id}/ocultar-comentarios`, null);
      post.comentariosOcultos = response.data.comentarios_ocultos;
  } catch (err) {
      console.error("Erro ao ocultar comentários:", err.response?.data || err);
  }
};

const removeImage = () => {
  newPostImage.value = null;
};

const removeDocument = () => {
  newPostDocuments.value = null;
  newPostDocumentName.value = null;
};

// Funções para posts
const createPost = async () => {
  if (!selectedGroupId.value && !isCoordenadorFeed.value) {
      alert("Selecione um grupo antes de publicar.");
      return;
  }

  const conteudoValido = newPostContent.value?.trim();
  
if (!conteudoValido) {
  alert("Digite algum conteúdo antes de publicar.");
  return;
}


  try {
      const formData = new FormData();
      formData.append("conteudo", newPostContent.value.trim());
      if (selectedGroupId.value) {
          formData.append("grupo_id", selectedGroupId.value);
      }

      // Adiciona múltiplos documentos se houver
      if (Array.isArray(newPostDocuments.value)) {
          newPostDocuments.value.forEach((doc) => {
              if (doc instanceof File) {
                  formData.append("documentos", doc);
              }
          });
      } else if (newPostDocuments.value instanceof File) {
          formData.append("documentos", newPostDocuments.value);
      }

      if (newPostImage.value) {
          const file = dataURLtoFile(newPostImage.value, "imagem.png");
          formData.append("imagem", file);
      }

      if (newPostVideo.value?.file) {
          formData.append("video", newPostVideo.value.file);
      }

      const response = await apiClient.post('/api/v1/feed/posts', formData);

      posts.value.unshift({
          id: response.data.id,
          author: {
              id: response.data.usuario_id,
              name: response.data.usuario_nome,
              avatar: response.data.usuario_imagem || CircleUserRound
          },
          content: response.data.conteudo,
          image: response.data.imagem_base64 || null,
          createdAt: response.data.data_criacao,
          likes: 0,
          total_comentarios: 0,
          userLiked: false,
          showComments: false,
          newComment: '',
          comments: [],
          documentos: [], // ← Adicione esta linha
          video: response.data.video_url || null,
          reactionUsersEmojis: [],
          reactionUsersPerEmoji: {},
          comentariosOcultos: false,
      });


      newPostContent.value = '';
      newPostImage.value = null;
      newPostVideo.value = null;
      newPostDocuments.value = null;
      newPostDocumentName.value = null;

  } catch (error) {
      console.error('Erro ao criar post:', error);
  }
  fetchPosts()
};

const verificarCoordenadorFeed = async () => {
  try {
      const response = await apiClient.get('/api/v1/feed/gruposfeed/eh-responsavel');
      isCoordenadorFeed.value = !!response.data?.eh_responsavel;
      canManageFeedGroups.value = !!response.data?.pode_gerenciar_grupos_feed;
      canCreateFeedGroups.value = !!response.data?.pode_criar_grupos_feed;
  } catch (error) {
      isCoordenadorFeed.value = false;
      canManageFeedGroups.value = false;
      canCreateFeedGroups.value = false;
  }
};

// função auxiliar para converter base64 em File
function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}


// Funções para comentários
const toggleComments = (postId) => {
  const post = posts.value.find(p => p.id === postId);
  if (post) {
      if ((post.total_comentarios || 0) > 0 && post.showComments) {
          return;
      }
      post.showComments = !post.showComments;
  }
};

const addComment = async (postId) => {
  const post = posts.value.find(p => p.id === postId);
  if (post && post.newComment.trim()) {
      try {
          const response = await apiClient.post(`/api/v1/feed/posts/${postId}/comentarios`, {
              comentario: post.newComment
          });

          post.comments.push({
              id: response.data.id,
              usuario_nome: response.data.usuario_nome,
              comentario: response.data.comentario,
              usuario_imagem: response.data.usuario_imagem || '/default-avatar.png', 
              data_criacao: response.data.data_criacao,
              userLiked: false,
              userReaction: null,
              likes: 0,
              reactionUsersEmojis: [],
              reactionUsersPerEmoji: {},
              showReplyInput: false,
              newReply: '',
              replyTargetId: null,
              replies: []
          });

          post.total_comentarios = (post.total_comentarios || 0) + 1;
          post.showComments = true;
          post.newComment = '';
      } catch (error) {
          console.error('Erro ao adicionar comentário:', error);
      }
  }
};

const toggleReplyInput = (postId, commentId) => {
  if (!userPermissoes.value.pode_responder_comentario) return;
  const post = posts.value.find(p => p.id === postId);
  if (!post) return;
  post.comments.forEach(comment => {
      if (comment.id === commentId) {
          comment.showReplyInput = !comment.showReplyInput;
          if (!comment.showReplyInput) {
              comment.replyTargetId = null;
          }
      } else {
          comment.showReplyInput = false;
          comment.replyTargetId = null;
      }
  });
};

const prepareReplyToReply = (postId, commentId, reply) => {
  if (!userPermissoes.value.pode_responder_comentario) return;
  const post = posts.value.find(p => p.id === postId);
  if (!post) return;
  const comment = post.comments.find(c => c.id === commentId);
  if (!comment) return;
  comment.showReplyInput = true;
  comment.replyTargetId = reply.id || null;
  if (!comment.newReply?.trim()) {
      comment.newReply = `@${reply.author?.name || 'usuário'} `;
  }
};

const addReply = async (postId, comment) => {
  if (!userPermissoes.value.pode_responder_comentario) return;
  if (!comment || !comment.newReply?.trim()) return;

  try {
      const formData = new FormData();
      formData.append("resposta", comment.newReply);
      if (comment.replyTargetId) {
          formData.append("resposta_pai_id", String(comment.replyTargetId));
      }

      const comentarioIdInt = parseInt(comment.id);
      if (isNaN(comentarioIdInt)) {
          console.error("comentario_id inválido:", comment.id);
          return;
      }

      const response = await apiClient.post(`/api/v1/feed/comments/${comentarioIdInt}/answers`, formData);

      const post = posts.value.find(p => p.id === postId);
      if (post) {
          const targetComment = post.comments.find(c => c.id === comment.id);
          if (targetComment) {
              targetComment.replies.push({
                  id: response.data.id || Date.now(),
                  author: {
                      name: response.data.usuario,
                      avatar: profileImage.value || '/default-avatar.png'
                  },
                  content: response.data.resposta,
                  createdAt: response.data.data_criacao,
                  userLiked: false
              });

              targetComment.newReply = '';
              targetComment.showReplyInput = false;
              targetComment.replyTargetId = null;
          }
      }

  } catch (err) {
      console.error('Erro ao enviar resposta:', err.response?.data || err);
  }
  atualizarPost(postId)
};

// Funções para reações
const reactToPost = async (postId, emoji) => {
  if (!userPermissoes.value.pode_reagir) return;
  const post = posts.value.find(p => p.id === postId);
  if (!post) return;

  try {
      await apiClient.post(`/api/v1/feed/posts/${postId}/reacoes`, { reacao: emoji });
      activeEmojiPostId.value = null;
      await atualizarPost(postId);
  } catch (error) {
      console.error('Erro ao reagir ao post:', error.response?.data || error);
  }
};

//const likeComment = (postId, commentId) => {
//    const post = posts.value.find(p => p.id === postId);
//   if (post) {
//       const comment = post.comments.find(c => c.id === commentId);
//        if (comment) {
//           comment.userLiked = !comment.userLiked;
//       }
//   }
//};

const reactToComment = async (postId, commentId, emoji) => {
  if (!userPermissoes.value.pode_reagir) return;
  const post = posts.value.find(p => p.id === postId);
  if (!post) return;
  const comment = post.comments.find(c => c.id === commentId);
  if (!comment) return;
  try {
      await apiClient.post(`/api/v1/feed/comments/${commentId}/reacoes`, { reacao: emoji });
      activeEmojiCommentId.value = null;
      await atualizarPost(postId);
  } catch (error) {
      console.error('Erro ao reagir ao comentário:', error.response?.data || error);
  }
};
const profileImage = ref('');
const editingPostId = ref(null);
const editedContent = ref('');
const startEditPost = (post) => {
  editingPostId.value = post.id;
  editedContent.value = post.content;
  closePostMenu();
};

const carregarPerfil = async () => {
try {
  
  
  const { data } = await apiClient.get('/api/v1/profile');

  if (data.imagem_base64) {
    profileImage.value = data.imagem_base64
      ? data.imagem_base64
      : data.imagem_base64;
  }
} catch (error) {
  console.error("Erro ao carregar perfil:", error);
  alert("Erro ao carregar perfil.");
}
};

const saveEditedPost = async (post) => {
  try {
      await apiClient.put(`/api/v1/feed/posts/${post.id}`, {
          conteudo: editedContent.value
      });

      post.content = editedContent.value + " (Editada)";
      editingPostId.value = null;
      editedContent.value = '';
  } catch (err) {
      console.error("Erro ao editar post:", err.response?.data || err);
  }
};

const isReactionsModalOpen = ref(false);
const reactionsModalPost = ref(null);
const reactionsModalTitle = ref('Reações');
watch(() => reactionsModalPost.value, (newVal) => {
  if (newVal && newVal.reactionUsersPerEmoji) {
      selectedEmojiTab.value = Object.keys(newVal.reactionUsersPerEmoji)[0] || null;
  }
});


const openReactionsModal = (post, title = 'Reações') => {
  if (!userPermissoes.value.pode_visualizar_reacoes) return;
  reactionsModalPost.value = post;
  reactionsModalTitle.value = title;
  isReactionsModalOpen.value = true;
};
const closeReactionsModal = () => {
  isReactionsModalOpen.value = false;
  reactionsModalPost.value = null;
  selectedEmojiTab.value = null;
};




const cancelEditPost = () => {
  editingPostId.value = null;
  editedContent.value = '';
};

const deletePost = async (postId) => {
  if (!confirm("Tem certeza que deseja excluir esta publicação?")) return;

  try {
      await apiClient.delete(`/api/v1/feed/posts/${postId}`);
      posts.value = posts.value.filter(p => p.id !== postId);
  } catch (err) {
      console.error("Erro ao excluir post:", err);
  }
};

const activePostMenuId = ref(null);

const mapReplyFromApi = (reply, fallbackId) => ({
  id: reply.id ?? fallbackId,
  author: {
      name: reply.usuario_nome || reply.usuario || 'Usuário',
      avatar: reply.usuario_imagem || '/default-avatar.png'
  },
  content: reply.resposta || '',
  createdAt: reply.data_criacao,
  resposta_pai_id: reply.resposta_pai_id || null,
  userLiked: false
});

const mapPostFromApi = (post) => ({
  id: post.id,
  author: {
    id: post.usuario_id,
    name: post.usuario_nome,
    avatar: post.usuario_imagem || '/default-avatar.png'
  },
  content: post.conteudo,
  image: post.imagem_base64 || null,
  createdAt: post.data_criacao,
  likes: post.reacoes.total,
  total_comentarios: post.total_comentarios,
  userLiked: post.reacoes.usuario_curtiu,
  reactionUsers: post.reacoes.usuarios_curtiram || [],
  userReaction: post.reacoes.reacao_usuario || null,
  showEmojiMenu: false,
  showComments: (post.total_comentarios || 0) > 0,
  newComment: '',
  reactionUsersEmojis: post.reacoes.emojis_distintos || [],
  reactionUsersPerEmoji: post.reacoes.emojis_por_usuario || {},
  comments: Array.isArray(post.comentarios)
    ? post.comentarios.map((comment, index) => mapCommentFromApi(comment, index))
    : [],
  comentariosOcultos: post.comentarios_ocultos,
  video: post.video_url || null,
  documentos: Array.isArray(post.documentos) ? post.documentos : []
});

const mapCommentFromApi = (comment, fallbackIndex = 0) => ({
  ...comment,
  id: comment.id ? Number(comment.id) : fallbackIndex,
  usuario_imagem: comment.usuario_imagem || '/default-avatar.png',
  userLiked: !!comment.usuario_curtiu,
  userReaction: comment.reacao_usuario || null,
  likes: comment.total_reacoes || 0,
  reactionUsersEmojis: comment.emojis_distintos || [],
  reactionUsersPerEmoji: comment.emojis_por_usuario || {},
  showReplyInput: false,
  newReply: '',
  replyTargetId: null,
  replies: Array.isArray(comment.respostas)
      ? comment.respostas.map((reply, index) => mapReplyFromApi(reply, `${comment.id || fallbackIndex}-r-${index}`))
      : []
});


const togglePostMenu = (postId) => {
  activePostMenuId.value = activePostMenuId.value === postId ? null : postId;
};

const closePostMenu = () => {
  activePostMenuId.value = null;
};

document.addEventListener('click', (e) => {
  if (!e.target.closest('.post-menu-wrapper')) closePostMenu();
});

// Funções para grupos
const toggleSidebar = () => {
  isSidebarVisible.value = !isSidebarVisible.value;
};

const selectGroup = (groupId) => {
  setSelectedGroupId(groupId);
  localStorage.setItem('grupoSelecionado', String(groupId));
  posts.value = [];
  aplicarPermissoesGrupoSelecionado();
  fetchPosts();
  isSidebarVisible.value = false; // Fecha o sidebar após selecionar
};
watch(selectedGroupId, (newGroupId) => {
  aplicarPermissoesGrupoSelecionado();
  if (newGroupId) {
    fetchPosts();
  }
});


const fetchPosts = async () => {
try {
  if (!userPermissoes.value.pode_visualizar_feed) {
    posts.value = [];
    feedAcessoNegado.value = true;
    return;
  }
  feedAcessoNegado.value = false;
  const url = selectedGroupId.value
    ? `/api/v1/feed/posts?grupo_id=${selectedGroupId.value}`
    : '/api/v1/feed/posts';

  const response = await apiClient.get(url);

  posts.value = response.data.length ? response.data.map(mapPostFromApi) : [];
  await focarPostDaRota();

} catch (error) {
  if (error?.response?.status === 403) {
    feedAcessoNegado.value = true;
  }
  console.error('Erro ao buscar posts:', error);
}
};

const obterGrupoPelaRota = () => {
  const valor = Number(route.params.groupId);
  return Number.isFinite(valor) && valor > 0 ? valor : null;
};

const obterPostPelaRota = () => {
  const valor = Number(route.params.postId);
  return Number.isFinite(valor) && valor > 0 ? valor : null;
};

const focarPostDaRota = async () => {
  const postId = obterPostPelaRota();
  if (!postId) return;
  const existe = posts.value.some(post => Number(post.id) === Number(postId));
  if (!existe) return;
  postEmFocoId.value = postId;
  await nextTick();
  const elemento = document.getElementById(`feed-post-${postId}`);
  if (elemento) {
    elemento.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  window.setTimeout(() => {
    if (postEmFocoId.value === postId) {
      postEmFocoId.value = null;
    }
  }, 3000);
};


const fetchGroups = async () => {
try {
  const response = await apiClient.get('/api/v1/feed/gruposfeedusuarios/', {
    withCredentials: true  
  });
  const gruposApi = Array.isArray(response.data) ? response.data : [];
  groups.value = gruposApi;
  aplicarPermissoesGrupoSelecionado();

  const grupoSelecionadoExiste = groups.value.some(grupo => grupo.id === selectedGroupId.value);
  if (!grupoSelecionadoExiste) {
    const primeiroGrupoDisponivel = groups.value[0]?.id ?? null;
    setSelectedGroupId(primeiroGrupoDisponivel);
    if (primeiroGrupoDisponivel) {
      localStorage.setItem('grupoSelecionado', String(primeiroGrupoDisponivel));
    } else {
      localStorage.removeItem('grupoSelecionado');
      posts.value = [];
    }
  }
} catch (error) {
  console.error("Erro ao buscar grupos:", error);
}
};


// Recarrega um único post do backend (reações, comentários) e o substitui na lista,
// em vez de buscar o feed inteiro a cada reação/comentário.
const atualizarPost = async (postId) => {
  const indice = posts.value.findIndex(p => p.id === postId);
  if (indice === -1) return;
  const anterior = posts.value[indice];
  // Mantém a quantidade de comentários já expandida pelo usuário
  const limit = Math.max(3, anterior.comments?.length || 0);
  const response = await apiClient.get(`/api/v1/feed/posts?post_id=${postId}&offset=0&limit=${limit}`);
  const postApi = response.data.find(p => p.id === postId);
  if (!postApi) return;
  const novo = mapPostFromApi(postApi);
  // Preserva estado de UI local
  novo.showComments = anterior.showComments;
  novo.newComment = anterior.newComment;
  novo.showEmojiMenu = false;
  posts.value.splice(indice, 1, novo);
};

const carregarMaisComentarios = async (post) => {
  try {
      const offset = post.comments.length;
      const response = await apiClient.get(`/api/v1/feed/posts?post_id=${post.id}&offset=${offset}&limit=3`);
      const postAtualizado = response.data.find(p => p.id === post.id);
      if (postAtualizado) {
          const comentariosMapeados = Array.isArray(postAtualizado.comentarios)
              ? postAtualizado.comentarios.map((comment, index) => mapCommentFromApi(comment, post.comments.length + index))
              : [];
          post.comments = [...post.comments, ...comentariosMapeados];
      }
  } catch (error) {
      console.error("Erro ao carregar mais comentários:", error);
  }
};

// Formatar data
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInMinutes = Math.floor((now - date) / (1000 * 60));

  if (diffInMinutes < 1) return 'Agora mesmo';
  if (diffInMinutes < 60) return `${diffInMinutes} min atrás`;

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return `${diffInHours} h atrás`;

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) return `${diffInDays} d atrás`;

  return date.toLocaleDateString('pt-BR');
};

onMounted(async () => {
const grupoDaRota = obterGrupoPelaRota();
if (grupoDaRota) {
  setSelectedGroupId(grupoDaRota);
  localStorage.setItem('grupoSelecionado', String(grupoDaRota));
} else {
  const grupoSalvo = localStorage.getItem('grupoSelecionado');
  if (grupoSalvo) {
    setSelectedGroupId(parseInt(grupoSalvo));
  }
}

const usuarioAtual = await getUser();
currentUserId.value = usuarioAtual?.id || null;
await verificarPermissaoPostagem();
await verificarCoordenadorFeed();
await fetchGroups();
aplicarPermissoesGrupoSelecionado();
carregarPerfil();

if (selectedGroupId.value) {
  await fetchPosts();
}
});

watch(() => [route.params.groupId, route.params.postId], async () => {
  const grupoDaRota = obterGrupoPelaRota();
  if (grupoDaRota && Number(selectedGroupId.value) !== Number(grupoDaRota)) {
    setSelectedGroupId(grupoDaRota);
    localStorage.setItem('grupoSelecionado', String(grupoDaRota));
    await fetchPosts();
    return;
  }
  await focarPostDaRota();
});



// Fechar menu de emojis quando clicar fora
watch(() => activeEmojiPostId.value, (newVal) => {
  if (newVal) {
      const closeOnClickOutside = (e) => {
          const emojiMenu = document.querySelector('.emoji-menu');
          if (emojiMenu && !emojiMenu.contains(e.target)) {
              activeEmojiPostId.value = null;
              document.removeEventListener('click', closeOnClickOutside);
          }
      };

      setTimeout(() => {
          document.addEventListener('click', closeOnClickOutside);
      }, 100);
  }
});
</script>
